import React from 'react'
import { ReactComponent as BendingArrowIconComponent } from '../../../assets/images/bending-arrow-anti-clockwise.svg'

interface BendingArrowIconProps {
  facing?: 'left' | 'right'
}

export const BendingArrowIcon: React.FC<BendingArrowIconProps> = ({ facing }) => {
  const rotation = facing === 'left' ? 'rotate(180)' : 'rotate(0)'

  return <BendingArrowIconComponent transform={rotation} fill='var(--zocks-gray-900)' />
}
